import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-loading-loader',
  templateUrl: './application-loading-loader.component.html',
  styleUrls: ['./application-loading-loader.component.css']
})
export class ApplicationLoadingLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
